import { scripts, styles} from '@/lib/vendors'

const asyncLoad = () => {

    let tag = document.getElementsByTagName('script')[0]

    scripts.forEach(s => {
        if( !s.include ) return ''

        let script = document.createElement('script')
            script.type = 'text/javascript'
            script.async = true
            script.src = s?.src

        if(window.vendors) script.addEventListener('load', () => window.vendors(s.name))
        if(s.callback) script.addEventListener('load', s.callback)

        tag.parentNode.insertBefore(script, tag)
    })

    styles.forEach(s => {
        if( !s.include ) return ''

        let script = document.createElement('link')
            script.rel = 'stylesheet'
            script.href = s?.src

        tag.parentNode.insertBefore(script, tag)

        if(s.callback) tag.addEventListener('load', s.callback)
    })
}

if(window.attachEvent) window.attachEvent('onload', asyncLoad)
else window.addEventListener('load', asyncLoad, false)